export const ERC1967ProxyAbi = [
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "logic",
                "type": "address"
            }
        ],
        "stateMutability": "payable",
        "type": "constructor"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "target",
                "type": "address"
            }
        ],
        "name": "AddressEmptyCode",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "implementation",
                "type": "address"
            }
        ],
        "name": "ERC1967InvalidImplementation",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ERC1967NonPayable",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "FailedInnerCall",
        "type": "error"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "implementation",
                "type": "address"
            }
        ],
        "name": "Upgraded",
        "type": "event"
    },
    {
        "stateMutability": "payable",
        "type": "fallback"
    }
];

export const ERC1967ProxyBytecode = "60806040526040516103543803806103548339810160408190526100229161025c565b6040805160048152602481019091526020810180516001600160e01b0390811663204a7f0760e21b1790915282919061005f908390839061006716565b505050610298565b610070826100c5565b6040516001600160a01b038316907fbc7cd75a20ee27fd9adebab32041f755214dbc6bffa90cc0225b39da2e5c2d3b905f90a28051156100b9576100b48282610140565b505050565b6100c16101b3565b5050565b806001600160a01b03163b5f036100ff57604051634c9c8ce360e01b81526001600160a01b03821660048201526024015b60405180910390fd5b7f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc80546001600160a01b0319166001600160a01b0392909216919091179055565b60605f80846001600160a01b03168460405161015c9190610282565b5f60405180830381855af49150503d805f8114610194576040519150601f19603f3d011682016040523d82523d5f602084013e610199565b606091505b5090925090506101aa8583836101d4565b95945050505050565b34156101d25760405163b398979f60e01b815260040160405180910390fd5b565b6060826101e9576101e482610233565b61022c565b815115801561020057506001600160a01b0384163b155b1561022957604051639996b31560e01b81526001600160a01b03851660048201526024016100f6565b50805b9392505050565b8051156102435780518082602001fd5b60405163d6bda27560e01b815260040160405180910390fd5b5f6020828403121561026c575f80fd5b81516001600160a01b038116811461022c575f80fd5b5f82518060208501845e5f920191825250919050565b60b0806102a45f395ff3fe6080604052600a600c565b005b60186014601a565b605d565b565b5f60587f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc5473ffffffffffffffffffffffffffffffffffffffff1690565b905090565b365f80375f80365f845af43d5f803e8080156076573d5ff35b3d5ffdfea2646970667358221220e365164efc3e69efea41be9e961146d33d9932a8a302bd1635ebc0620b8cee8b64736f6c634300081a0033";

export default { ERC1967ProxyAbi, ERC1967ProxyBytecode };
